import { useEffect } from "react";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Book } from "@/components/landing/Book";
import { Gallery } from "@/components/landing/Gallery";
import { Watch } from "@/components/landing/Watch";
import { Contents } from "@/components/landing/Contents";
import { Join } from "@/components/landing/Join";
import { Author } from "@/components/landing/Author";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

export default function Landing() {
  useEffect(() => {
    document.title = "Families, Reimagined — Zarya Thomas | Coming 2027";
    const els = document.querySelectorAll(".fr-reveal");
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && (e.target.classList.add("is-in"), io.unobserve(e.target))),
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="bg-marigold text-ink font-body" data-testid="landing-page">
      <Nav />
      <Hero />
      <Book />
      <Gallery />
      <Watch />
      <Contents />
      <Join />
      <Author />
      <Contact />
      <Footer />
    </div>
  );
}
